import React, { useEffect, useState } from "react";

const CheckBox = (props) => {
  const {
    labelTitle,
    id,
    onCheckedChange,
    register,
    name,
    disabled,
    checkboxClass,
    checkedState,
  } = props;
  const [checked, setChecked] = useState(!checkedState);

  /**
   * useEffect hook that updates the state of the checkbox when the checked prop changes.
   * @param {object} props - The props object containing the checked prop.
   * @returns None
   */
  useEffect(() => {
    setChecked(checkedState);
  }, [checkedState]);

  /**
   * Updates the state of the checkbox and calls the onCheckedChange function if it exists.
   * @param {object} e - the event object
   * @returns None
   */
  const onChecked = (e) => {
    setChecked(e.target.checked);
    onCheckedChange && onCheckedChange(e.target.checked);
  };

  return (
    <div className="checkboxMain">
      <input
        type="checkbox"
        ref={register}
        disabled={disabled}
        name={name}
        value={labelTitle}
        id={id}
        className={"checkbox " + checkboxClass}
        checked={checked}
        onChange={onChecked}
      />
      <label className="checkboxLabel" id="checkLabel" htmlFor={id}>
        {labelTitle}
      </label>
    </div>
  );
};

CheckBox.defaultProps = {
  id: "",
  checked: false,
  labelTitle: "Title",
};

export default CheckBox;
